function $19ce7e3c9d6231eb$export$7e553efa7989e1cf() {
    return `
    <div class="min-h-screen">
      <!-- Hero Section -->
      <section class="container-wide py-16 sm:py-24" aria-labelledby="hero-heading">
        <div class="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          <div class="lg:col-span-3 anim-reveal">
            <span class="section-label">Portfolio</span>
            <h1 id="hero-heading" class="font-display font-extrabold text-display-xl mb-6" style="color: var(--text-primary)">
              Arthur<br>Miconnet
            </h1>
            <p class="font-display font-semibold text-display-md mb-6" style="color: var(--color-primary)">
              UX/UI Designer
            </p>
            <p class="font-body text-body-lg max-w-xl mb-10" style="color: var(--text-secondary)">
              26 ans, 4+ ans d'experience. Dynamique et curieux, je transforme la complexite
              metier en parcours simples. Recherche ciblee, prototypage rapide, mesure post-lancement.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="#projects" class="btn-primary">
                Voir mes projets
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </a>
              <a href="mailto:arthur.miconnet1@gmail.com" class="btn-secondary">
                Me contacter
              </a>
            </div>
          </div>
          <div class="lg:col-span-2 flex justify-center anim-reveal-scale delay-2">
            <div class="w-56 h-56 sm:w-64 sm:h-64 rounded-3xl overflow-hidden anim-float" style="box-shadow: 0 20px 60px rgba(67, 56, 202, 0.12);">
              <img src="${document.querySelector('[data-asset="arthur"]')?.getAttribute('src') || ''}"
                   alt="Photo de Arthur Miconnet, UX/UI Designer"
                   class="w-full h-full object-cover"
                   loading="eager"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div style=\\'background: var(--color-primary); width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem; font-weight: 700; font-family: Sora, sans-serif;\\'>AM</div>'">
            </div>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- About Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="about-heading">
        <div class="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <!-- Formation -->
          <div class="anim-reveal">
            <span class="section-label">Formation</span>
            <h2 id="about-heading" class="section-title">Parcours</h2>
            <div class="space-y-6">
              <div class="timeline-item">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">MBA Expert UX/UI Designer</h3>
                <p class="font-body text-body-md" style="color: var(--text-secondary)">MyDigitalSchool, Lyon</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">2020 - 2023</p>
              </div>
              <div class="timeline-item">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">BTS SIO</h3>
                <p class="font-body text-body-md" style="color: var(--text-secondary)">Formation HTML, CSS, PHP</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">2017 - 2020</p>
              </div>
            </div>
          </div>

          <!-- Informations -->
          <div class="anim-reveal delay-2">
            <span class="section-label">Informations</span>
            <h2 class="section-title">Contact</h2>
            <ul class="space-y-4" role="list">
              <li>
                <a href="mailto:arthur.miconnet1@gmail.com" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">arthur.miconnet1@gmail.com</span>
                </a>
              </li>
              <li>
                <a href="tel:+33673208198" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">06 73 20 81 98</span>
                </a>
              </li>
              <li>
                <a href="https://am-dev.eu" target="_blank" rel="noopener noreferrer" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)" aria-label="Site web am-dev.eu (ouvre un nouvel onglet)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">am-dev.eu</span>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/arthur-miconnet" target="_blank" rel="noopener noreferrer" class="group flex items-center gap-4 font-body text-body-md py-2 transition-colors" style="color: var(--text-secondary)" aria-label="Profil LinkedIn d'Arthur Miconnet (ouvre un nouvel onglet)">
                  <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                    <svg class="w-5 h-5" style="color: var(--color-primary)" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                    </svg>
                  </span>
                  <span class="group-hover:underline">@Arthur Miconnet</span>
                </a>
              </li>
              <li class="flex items-center gap-4 font-body text-body-md py-2" style="color: var(--text-secondary)">
                <span class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(67, 56, 202, 0.06);">
                  <svg class="w-5 h-5" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"></path>
                  </svg>
                </span>
                <span>Anglais C1</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Skills Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="skills-heading">
        <div class="text-center mb-12 anim-reveal">
          <span class="section-label">Expertise</span>
          <h2 id="skills-heading" class="section-title">Competences</h2>
        </div>
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- Design UX/UI -->
          <div class="card p-8 anim-reveal delay-1">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Design UX/UI</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>Recherche utilisateur</li>
              <li>Prototypage & tests</li>
              <li>Design system</li>
              <li>Accessibilite</li>
            </ul>
          </div>

          <!-- Developpement -->
          <div class="card p-8 anim-reveal delay-2">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Developpement</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>SQL & dev</li>
              <li>HTML, CSS, PHP</li>
              <li>Integration responsive</li>
              <li>Azure DevOps</li>
            </ul>
          </div>

          <!-- Autres -->
          <div class="card p-8 anim-reveal delay-3">
            <div class="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.08);">
              <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <h3 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">Autres</h3>
            <ul class="space-y-2 font-body text-body-md" style="color: var(--text-secondary)" role="list">
              <li>Marketing, SEO / SEA</li>
              <li>Methodologie de projet</li>
              <li>Figma, Adobe XD, Sketch</li>
              <li>Adobe Creative Suite</li>
            </ul>
          </div>
        </div>

        <!-- Qualites -->
        <div class="mt-12 text-center anim-reveal">
          <h3 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Qualites</h3>
          <div class="flex flex-wrap justify-center gap-3">
            <span class="tag !px-6 !py-3 !text-body-sm">Curieux</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Rigoureux</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Creatif</span>
            <span class="tag !px-6 !py-3 !text-body-sm">Dynamique</span>
          </div>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Experience Section -->
      <section class="container-wide py-16 sm:py-20" aria-labelledby="experience-heading">
        <div class="max-w-3xl mx-auto">
          <div class="mb-12 anim-reveal">
            <span class="section-label">Parcours</span>
            <h2 id="experience-heading" class="section-title">Experience</h2>
          </div>

          <div class="space-y-0">
            <!-- OKTEO -->
            <article class="timeline-item anim-reveal delay-1">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">UX/UI Designer</h3>
                <span class="tag !text-caption">2022 - 2025</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">OKTEO, Ceyzeriat</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Conception d'interfaces des solutions SaaS : recherche utilisateur, maquettes,
                design system et suivi des developpements dans Azure DevOps.
              </p>
            </article>

            <!-- Avenir Multimedia -->
            <article class="timeline-item anim-reveal delay-2">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Integrateur Web</h3>
                <span class="tag !text-caption">2021 - 2022</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">Avenir Multimedia, Lyon</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Integration responsive, optimisation des performances et mise en ligne
                de sites vitrine et e-commerce.
              </p>
            </article>

            <!-- Wanimo -->
            <article class="timeline-item anim-reveal delay-3">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Graphiste</h3>
                <span class="tag !text-caption">2020 - 2021</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">Wanimo, Lyon</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Creation de visuels web et print, declinaisons reseaux sociaux et
                participation a la refonte mobile du site.
              </p>
            </article>

            <!-- CREA2F -->
            <article class="timeline-item anim-reveal delay-4">
              <div class="flex flex-wrap justify-between items-start gap-2 mb-1">
                <h3 class="font-display font-bold text-body-lg" style="color: var(--text-primary)">Developpeur Web</h3>
                <span class="tag !text-caption">2018</span>
              </div>
              <p class="font-body font-medium text-body-sm mb-2" style="color: var(--color-primary)">CREA2F, Toulouse</p>
              <p class="font-body text-body-md" style="color: var(--text-secondary)">
                Developpement de modules intranet en PHP / Bootstrap et implementation
                d'un moteur de recherche interne.
              </p>
            </article>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="cta-heading">
        <div class="container-narrow text-center">
          <div class="anim-reveal">
            <span class="section-label">Collaboration</span>
            <h2 id="cta-heading" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">
              Travaillons ensemble
            </h2>
            <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">
              Vous avez un projet en tete ? Discutons-en !
            </p>
            <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
              <span>Me contacter</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  `;
}


function $d634af5b184669af$export$34332b0cbc04fc0d() {
    return `
    <div class="min-h-screen">
      <!-- Page Header -->
      <section class="container-wide py-16 sm:py-24" aria-labelledby="projects-heading">
        <div class="max-w-3xl anim-reveal">
          <span class="section-label">Portfolio</span>
          <h1 id="projects-heading" class="font-display font-extrabold text-display-xl mb-6" style="color: var(--text-primary)">
            Mes Projets
          </h1>
          <p class="font-body text-body-lg" style="color: var(--text-secondary)">
            Decouvrez une selection de mes realisations en UX/UI design
          </p>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Projects Grid -->
      <section class="container-wide py-16 sm:py-20" aria-label="Liste des projets">
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          <!-- Project Card 1 - Plan de Travail -->
          <a href="#/project/plan-de-travail" class="card block overflow-hidden group anim-reveal delay-1" aria-label="Projet Plan de Travail - Dashboard de planification annuelle">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="plan-de-travail"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">Plan de Travail</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Dashboard de planification annuelle des pesees avec automatisation hebdomadaire et suivi des ecarts.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Dashboard</span>
                <span class="tag">Planification</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Project Card 2 - Agrilib -->
          <a href="#/project/agrilib" class="card block overflow-hidden group anim-reveal delay-2" aria-label="Projet Agrilib - Plateforme de reservation agricole">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="agrilib-accueil"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">Agrilib</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Plateforme de mise en relation et de reservation en ligne entre agriculteurs et prestataires.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Web App</span>
                <span class="tag">Marketplace</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Project Card 3 - AOP Saint-Nectaire -->
          <a href="#/project/saintnectaire" class="card block overflow-hidden group anim-reveal delay-3" aria-label="Projet AOP Saint-Nectaire - Maquettes mobile">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-iphone"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">AOP Saint-Nectaire</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Proposition graphique mobile pour le site vitrine de l'Interprofession Saint-Nectaire.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Mobile</span>
                <span class="tag">Maquettes</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Coming Soon -->
          <div class="card flex flex-col items-center justify-center text-center p-8 sm:p-10 min-h-[24rem] anim-reveal delay-4" style="border-style: dashed;">
            <div class="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.06);">
              <svg class="w-7 h-7" style="color: var(--color-primary); opacity: 0.6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
              </svg>
            </div>
            <h2 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">D'autres projets arrivent bientot</h2>
            <p class="font-body text-body-md max-w-xs" style="color: var(--text-secondary)">
              De nouveaux projets seront ajoutes prochainement pour enrichir mon portfolio.
            </p>
          </div>

        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="projects-cta-heading">
        <div class="container-narrow text-center">
          <div class="anim-reveal">
            <span class="section-label">Collaboration</span>
            <h2 id="projects-cta-heading" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">
              Interesse par mon travail ?
            </h2>
            <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">
              Je serais ravi de discuter de votre prochain projet
            </p>
            <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
              <span>Commencons un projet ensemble</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  `;
}


function $b3ccd696e766b50c$export$b9d32e483cb00d41() {
    return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="project-title">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="plan-de-travail"]')?.getAttribute('src') || ''}"
                 alt="Apercu du dashboard Plan de Travail"
                 class="w-full h-full object-cover"
                 loading="eager"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Dashboard</span>
              <span class="tag">Planification</span>
              <span class="tag">Automatisation</span>
            </div>
            <h1 id="project-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Plan de Travail</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Dashboard de planification annuelle des pesees avec automatisation hebdomadaire et suivi des ecarts pour les agents terrain et eleveurs.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-1">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Conception d'un nouveau dashboard de planification annuelle des pesees et du materiel associe. Cible : agents terrain et eleveurs ; objectif : planifier, executer automatiquement chaque semaine, suivre les ecarts.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee :</strong> Reponse a AO, maquettes livrees en 2 semaines.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              L'outil existant ne gerait pas bien les contraintes croisees (disponibilites agents/eleveurs, protocoles, materiel), generant conflits et perte de temps.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Reduire les conflits de planning</li>
                <li>Automatiser l'ordonnancement hebdo</li>
                <li>Fiabiliser le suivi</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>
            <div class="grid sm:grid-cols-2 gap-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Vue Plan</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Grille avec filtres, densite ajustable, et indicateurs de saturation</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Generation automatique</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Hebdomadaire avec journal d'ordonnancement et motifs de decisions</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Suivi des ecarts</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Alertes, replanification rapide, historique horodate</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Details intervention</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Protocole, materiel, contraintes, distance estimee</p>
              </div>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Baisse des conflits</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">de planning</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Gain de temps</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">sur la preparation hebdo</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Meilleure tracabilite</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">des ecarts</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="detail-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="detail-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}


function $f463fdfade830aad$export$4ef5429a2f4cd619() {
    return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="agrilib-title">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="agrilib-accueil"]')?.getAttribute('src') || ''}"
                 alt="Agrilib - Page d'accueil de la plateforme"
                 class="w-full h-full object-cover"
                 loading="eager"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Web App</span>
              <span class="tag">Mobile</span>
              <span class="tag">Marketplace</span>
            </div>
            <h1 id="agrilib-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Agrilib</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Plateforme de mise en relation et de reservation en ligne entre agriculteurs et prestataires de services agricoles.
            </p>
          </div>
        </div>
      </section>

      <!-- Secondary image -->
      <section class="container-wide pb-12 anim-reveal delay-1" aria-label="Fonctionnalite de recherche">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="agrilib-recherche"]')?.getAttribute('src') || ''}"
                 alt="Agrilib - Interface de recherche et reservation"
                 class="w-full h-full object-cover"
                 loading="lazy"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-8">
            <h2 class="font-display font-bold text-body-lg mb-2" style="color: var(--text-primary)">Systeme de recherche et reservation</h2>
            <p class="font-body text-body-md" style="color: var(--text-secondary)">
              Interface intuitive permettant aux agriculteurs de rechercher et reserver des prestations avec geolocalisation et disponibilites en temps reel.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet Agrilib">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-3" style="color: var(--text-secondary)">
              <strong style="color: var(--text-primary)">Concept :</strong> Mise en relation agriculteurs / prestataires, reservation en ligne, web + app Android.
            </p>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              <strong style="color: var(--text-primary)">Cibles :</strong> Exploitants agricoles.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee v1 :</strong> Annuaire geolocalise, fiche prestataire, agenda, reservation, back-office prestataire et admin.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Recherche morcelee, telephones/aller-retour, indisponibilites peu visibles.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Centraliser l'offre locale</li>
                <li>Afficher des creneaux reels</li>
                <li>Reduire la friction de planification</li>
                <li>Outiller les prestataires</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>
            <div class="grid sm:grid-cols-3 gap-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Exploitant</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Recherche activite+lieu, liste tri distance/dispo, fiche, choix creneau, confirmation</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Prestataire</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Onboarding, agenda (creneaux, exceptions), notifications email/SMS, stats</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Admin</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Moderation profils/categories, gestion communes/zones, support</p>
              </div>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-5">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6 mb-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Moins d'appels</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Communication simplifiee</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Planning mieux rempli</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Optimisation des creneaux</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Visibilite des creneaux</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">Disponibilites en temps reel</p>
              </div>
            </div>
            <div class="grid sm:grid-cols-2 gap-4">
              <div class="p-4 rounded-xl border-l-4 border-amber-500" style="background-color: rgba(245, 158, 11, 0.04);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Risques identifies</h3>
                <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                  <li>Adoption lente</li>
                  <li>Disponibilites incompletes</li>
                  <li>Couverture inegale</li>
                </ul>
              </div>
              <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Mesures correctives</h3>
                <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                  <li>Onboarding assiste + import creneaux</li>
                  <li>Rappels SMS/email</li>
                  <li>Pilotes par departement</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="agrilib-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="agrilib-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}


function $1a34e6f03fa81085$export$62ead6d5ed01702() {
    return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="sn-title">
        <div class="card overflow-hidden">
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Mobile</span>
              <span class="tag">Maquettes</span>
              <span class="tag">AOP</span>
            </div>
            <h1 id="sn-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">AOP Saint-Nectaire</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Proposition graphique mobile pour le site vitrine de l'Interprofession Saint-Nectaire. Livrable : maquettes haute fidelite mobile uniquement.
            </p>
          </div>

          <!-- Side-by-side images -->
          <div class="grid sm:grid-cols-2 gap-4 p-6 sm:p-10 pt-0">
            <div class="rounded-2xl overflow-hidden" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-iphone"]')?.getAttribute('src') || ''}"
                   alt="AOP Saint-Nectaire - Maquette mobile sur iPhone"
                   class="w-full h-auto"
                   loading="eager"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center p-8\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="rounded-2xl overflow-hidden" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-accueil"]')?.getAttribute('src') || ''}"
                   alt="AOP Saint-Nectaire - Vue d'ensemble de la maquette"
                   class="w-full h-auto"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center p-8\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
          </div>

          <div class="px-6 sm:px-10 pb-8">
            <p class="font-body text-body-md" style="color: var(--text-secondary)">
              Architecture de l'information optimisee pour un acces rapide aux actualites, newsletters et petites annonces.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet Saint-Nectaire">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-1">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Reponse a appel d'offres pour une proposition graphique mobile uniquement. Cible : Interprofession Saint-Nectaire.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee :</strong> Maquettes haute fidelite mobile, aucune implementation ni developpement.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Visibilite inegale des contenus cles et hierarchie editoriale confuse sur mobile.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Clarifier le message AOP</li>
                <li>Acces immediat aux Actualites, Newsletters et Annonces</li>
                <li>Base UI coherente et accessible</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>

            <div class="p-5 rounded-xl mb-4" style="background-color: var(--bg-subtle);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Parcours mobile</h3>
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                Accueil avec blocs empiles : <strong>Actualites</strong>, <strong>Dernieres newsletters</strong>, <strong>Petites annonces</strong>
              </p>
              <p class="font-body text-body-sm mt-1" style="color: var(--text-secondary)">
                Navigation inferieure (tab bar) : <strong>Accueil / Resultats / Actualites / Annonces / Contact</strong>
              </p>
            </div>

            <div class="grid sm:grid-cols-3 gap-4 mb-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Actualites</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste filtrable, cartes titre+date, gabarit article</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Newsletters</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste datee, acces rapide aux editions</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Petites annonces</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Liste + fiche, CTA "Voir toutes les annonces"</p>
              </div>
            </div>

            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Systeme UI mobile</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Composants reutilisables (cartes, boutons, listes, pagination, formulaires)</li>
                <li>Etats d'interaction et focus visibles</li>
                <li>Recommandations accessibilite et performance</li>
              </ul>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Comprehension immediate</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">de l'offre AOP</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Hausse des clics</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">vers Actualites et Annonces</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Coherence visuelle</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">base prete pour industrialisation</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="sn-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="sn-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design mobile</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}


class $0cbfff686ca3cb2c$export$8ad3ff08a59ee147 {
    constructor(){
        this.state = {
            isOpen: false,
            messages: [
                {
                    role: 'assistant',
                    content: 'Bonjour ! Je suis l\'assistant virtuel d\'Arthur Miconnet. Je peux repondre a vos questions sur son parcours, ses competences, ses projets ou comment le contacter. Comment puis-je vous aider ?',
                    timestamp: new Date()
                }
            ]
        };
        this.container = null;
        this.errorElement = null;
        this.render();
        this.attachEventListeners();
    }
    render() {
        const chatbotHTML = `
      <!-- Chatbot Toggle Button -->
      <button
        id="chatbot-button"
        class="fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50 flex items-center justify-center"
        style="background-color: var(--color-primary);"
        aria-label="Ouvrir le chatbot"
        aria-expanded="false"
        aria-controls="chatbot-window">
        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
        </svg>
      </button>

      <!-- Chatbot Window -->
      <div
        id="chatbot-window"
        role="dialog"
        aria-label="Assistant virtuel du portfolio"
        aria-modal="false"
        class="fixed bottom-24 right-4 sm:right-6 w-[calc(100vw-2rem)] sm:w-full max-w-md h-[min(500px,calc(100vh-8rem))] z-50 flex flex-col overflow-hidden transition-all duration-300 origin-bottom-right rounded-2xl"
        style="display: none; opacity: 0; transform: scale(0.9); background-color: var(--bg-elevated); border: 1px solid var(--border-color); box-shadow: 0 20px 60px rgba(0,0,0,0.12);">

        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b" style="border-color: var(--border-color);">
          <div class="flex items-center gap-3">
            <div class="w-9 h-9 rounded-xl flex items-center justify-center font-display font-bold text-white text-xs" style="background-color: var(--color-primary);">
              AM
            </div>
            <div>
              <h2 class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Assistant Portfolio</h2>
              <p class="font-body text-caption" style="color: var(--text-tertiary)">En ligne</p>
            </div>
          </div>
          <button
            id="chatbot-close"
            class="w-9 h-9 rounded-lg flex items-center justify-center transition-colors"
            style="color: var(--text-tertiary);"
            aria-label="Fermer le chatbot">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Messages -->
        <div
          id="chatbot-messages"
          class="flex-1 overflow-y-auto p-4 space-y-3"
          style="background-color: var(--bg-subtle);"
          role="log"
          aria-live="polite"
          aria-label="Historique des messages">
        </div>

        <!-- Input -->
        <div class="p-4 border-t" style="border-color: var(--border-color); background-color: var(--bg-elevated);">
          <div class="flex gap-2">
            <label for="chatbot-input" class="sr-only">Votre message</label>
            <input
              type="text"
              id="chatbot-input"
              placeholder="Posez votre question..."
              autocomplete="off"
              class="flex-1 px-4 py-2.5 rounded-xl border font-body text-body-sm transition-colors"
              style="border-color: var(--border-color); background-color: var(--bg-subtle); color: var(--text-primary);"
              aria-describedby="chatbot-error"
            />
            <button
              id="chatbot-send"
              class="w-11 h-11 rounded-xl flex items-center justify-center transition-all text-white flex-shrink-0"
              style="background-color: var(--color-primary);"
              aria-label="Envoyer le message">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
              </svg>
            </button>
          </div>

          <!-- Quick Questions -->
          <div class="mt-3 flex flex-wrap gap-2" id="quick-questions" role="group" aria-label="Questions rapides">
            <button class="quick-question font-body text-caption px-3 py-1.5 rounded-full transition-colors" style="background-color: rgba(67, 56, 202, 0.06); color: var(--color-primary);">
              Quel est son parcours ?
            </button>
            <button class="quick-question font-body text-caption px-3 py-1.5 rounded-full transition-colors" style="background-color: rgba(67, 56, 202, 0.06); color: var(--color-primary);">
              Quelles competences ?
            </button>
            <button class="quick-question font-body text-caption px-3 py-1.5 rounded-full transition-colors" style="background-color: rgba(67, 56, 202, 0.06); color: var(--color-primary);">
              Comment le contacter ?
            </button>
          </div>

          <p id="chatbot-error" class="mt-2 font-body text-body-sm" style="color: #EF4444; display: none;" role="alert" aria-live="assertive"></p>
        </div>
      </div>
    `;
        const div = document.createElement('div');
        div.id = 'chatbot-container';
        div.innerHTML = chatbotHTML;
        document.body.appendChild(div);
        this.container = div;
        this.errorElement = document.getElementById('chatbot-error');
        this.renderMessages();
    }
    sanitizeHTML(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
    renderMessages() {
        const messagesContainer = document.getElementById('chatbot-messages');
        if (!messagesContainer) return;
        messagesContainer.innerHTML = this.state.messages.map((msg)=>{
            const isUser = msg.role === 'user';
            return `
        <div class="flex ${isUser ? 'justify-end' : 'justify-start'}">
          <div class="max-w-[80%] rounded-2xl px-4 py-3 ${isUser ? '' : ''}" style="${isUser ? 'background-color: var(--color-primary); color: white;' : 'background-color: var(--bg-elevated); color: var(--text-primary); border: 1px solid var(--border-color);'}">
            <p class="font-body text-body-sm whitespace-pre-wrap">${this.sanitizeHTML(msg.content)}</p>
          </div>
        </div>
      `;
        }).join('');
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
    attachEventListeners() {
        const button = document.getElementById('chatbot-button');
        const closeBtn = document.getElementById('chatbot-close');
        button?.addEventListener('click', ()=>this.toggleChatbot());
        closeBtn?.addEventListener('click', ()=>this.toggleChatbot());
        const sendBtn = document.getElementById('chatbot-send');
        const input = document.getElementById('chatbot-input');
        sendBtn?.addEventListener('click', ()=>this.sendMessage());
        input?.addEventListener('keypress', (e)=>{
            if (e.key === 'Enter') this.sendMessage();
        });
        document.addEventListener('click', (e)=>{
            const target = e.target;
            if (target.classList.contains('quick-question')) {
                const question = target.textContent?.trim();
                if (question) {
                    const inp = document.getElementById('chatbot-input');
                    if (inp) {
                        inp.value = question;
                        this.sendMessage();
                    }
                }
            }
        });
        // Close on Escape
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && this.state.isOpen) this.toggleChatbot();
        });
    }
    toggleChatbot() {
        this.state.isOpen = !this.state.isOpen;
        const chatWindow = document.getElementById('chatbot-window');
        const button = document.getElementById('chatbot-button');
        if (!chatWindow || !button) return;
        button.setAttribute('aria-expanded', String(this.state.isOpen));
        if (this.state.isOpen) {
            chatWindow.style.display = 'flex';
            button.setAttribute('aria-label', 'Fermer le chatbot');
            setTimeout(()=>{
                chatWindow.style.opacity = '1';
                chatWindow.style.transform = 'scale(1)';
                // Focus the input when opened
                const input = document.getElementById('chatbot-input');
                input?.focus();
            }, 10);
        } else {
            chatWindow.style.opacity = '0';
            chatWindow.style.transform = 'scale(0.9)';
            button.setAttribute('aria-label', 'Ouvrir le chatbot');
            // Return focus to the toggle button
            button.focus();
            setTimeout(()=>{
                chatWindow.style.display = 'none';
            }, 300);
        }
    }
    sendMessage() {
        const input = document.getElementById('chatbot-input');
        if (!input) return;
        const userMessage = input.value.trim();
        if (!userMessage) {
            this.showError('Merci de saisir un message.');
            return;
        }
        if (userMessage.length < 2) {
            this.showError('Merci d\'utiliser au moins 2 caracteres.');
            return;
        }
        if (userMessage.length > 1000) {
            this.showError('Le message est trop long (maximum 1000 caracteres).');
            return;
        }
        this.showError('');
        input.value = '';
        this.state.messages.push({
            role: 'user',
            content: userMessage,
            timestamp: new Date()
        });
        this.renderMessages();
        setTimeout(()=>{
            const response = this.getResponse(userMessage);
            this.state.messages.push({
                role: 'assistant',
                content: response,
                timestamp: new Date()
            });
            this.renderMessages();
        }, 500);
    }
    showError(message) {
        if (!this.errorElement) return;
        this.errorElement.textContent = message;
        this.errorElement.style.display = message ? 'block' : 'none';
    }
    getResponse(message) {
        const lowerMessage = message.toLowerCase();
        if (lowerMessage.match(/parcours|formation|étude|diplôme|école/)) return `Arthur a un parcours complet en UX/UI Design :

Formation :
- MBA Expert UX/UI Designer - MyDigitalSchool, Lyon (2020-2023)
- BTS SIO - Formation HTML, CSS, PHP (2017-2020)

Il a 4+ ans d'experience professionnelle dans le design d'interfaces et l'UX/UI. Souhaitez-vous en savoir plus sur son experience professionnelle ?`;
        if (lowerMessage.match(/expérience|travail|emploi|poste|okteo|wanimo/)) return `Arthur a une solide experience professionnelle :

Experiences cles :
- UX/UI Designer chez OKTEO (2022-2025) - Alternance puis CDI
  Conception d'interfaces SaaS, design system, Azure DevOps

- Integrateur Web chez Avenir Multimedia (2021-2022)
  Integration responsive, optimisation performances

- Graphiste chez Wanimo (2020-2021)
  Visuels web/print, refonte mobile

- Developpeur Web chez CREA2F (2018)
  Modules intranet PHP/Bootstrap

Il cumule donc plus de 4 ans d'experience dans le digital !`;
        if (lowerMessage.match(/compétence|skill|savoir|maîtrise|outil|logiciel|technologie/)) return `Arthur possede un large eventail de competences :

Design UX/UI :
- Recherche utilisateur & tests
- Prototypage & maquettage
- Design system & accessibilite
- Figma, Adobe XD, Sketch

Developpement :
- HTML, CSS, PHP, SQL
- Integration responsive
- Azure DevOps

Autres competences :
- Marketing, SEO/SEA
- Adobe Creative Suite
- Methodologie de projet
- Anglais C1

Une competence particuliere vous interesse ?`;
        if (lowerMessage.match(/contact|joindre|email|téléphone|appel|écrire|linkedin/)) return `Vous pouvez contacter Arthur via :

Email : arthur.miconnet1@gmail.com
Telephone : 06 73 20 81 98
Site web : am-dev.eu
LinkedIn : @Arthur Miconnet

Il est disponible pour discuter de vos projets UX/UI !`;
        if (lowerMessage.match(/projet|réalisation|portfolio|travaux|créations/)) return `Arthur a travaille sur divers projets UX/UI, notamment :

- Solutions SaaS chez OKTEO
- Sites e-commerce et vitrines
- Design systems et interfaces
- Refontes mobiles

Pour voir ses projets en detail, je vous invite a consulter la section "Projets" du portfolio. Voulez-vous connaitre ses competences ou son experience ?`;
        if (lowerMessage.match(/qualité|personnalité|caractère|atout|point fort/)) return `Arthur se distingue par ses qualites professionnelles :

Curieux - Toujours en veille sur les nouvelles tendances UX/UI
Rigoureux - Methodique dans ses approches de conception
Creatif - Capacite a proposer des solutions innovantes
Dynamique - Proactif et engage dans ses projets

Il transforme la complexite metier en parcours simples grace a la recherche ciblee, le prototypage rapide et la mesure post-lancement.`;
        if (lowerMessage.match(/disponible|disponibilité|recrut|embauche|poste|cdi|freelance/)) return `Pour connaitre la disponibilite d'Arthur et discuter d'opportunites, je vous invite a le contacter directement :

Email : arthur.miconnet1@gmail.com
Telephone : 06 73 20 81 98

Il sera ravi d'echanger avec vous sur vos besoins !`;
        if (lowerMessage.match(/âge|ans|vieux|jeune|né|naissance/)) return `Arthur a 26 ans et cumule deja 4+ ans d'experience dans le design UX/UI. Il possede egalement le permis B et parle anglais au niveau C1.`;
        if (lowerMessage.match(/où|ville|région|lyon|localisation|habite/)) return `Arthur a travaille dans la region Auvergne-Rhone-Alpes, notamment a Lyon et Ceyzeriat. Il possede le permis B, ce qui lui offre une bonne mobilite.

Pour plus d'informations sur sa disponibilite geographique, contactez-le a : arthur.miconnet1@gmail.com`;
        if (lowerMessage.match(/\b(bonjour|salut|hello|hi|hey|coucou)\b/)) return `Bonjour ! Comment puis-je vous aider a en savoir plus sur Arthur Miconnet ? Je peux vous renseigner sur son parcours, ses competences, ses projets ou comment le contacter.`;
        if (lowerMessage.match(/merci|thanks|thx/)) return `Je vous en prie ! N'hesitez pas si vous avez d'autres questions sur Arthur. Bonne visite du portfolio !`;
        return `Je peux vous renseigner sur :

- Son parcours et sa formation
- Son experience professionnelle
- Ses competences et outils
- Comment le contacter
- Ses qualites et sa personnalite
- Ses projets

Quelle information recherchez-vous ?`;
    }
}


class $c6ec661f1b25b0fd$export$173e0a822059eddc {
    constructor(){
        this.isDark = false;
        this.storageKey = 'theme-preference';
        this.toggleButton = null;
        this.toggleButton = document.getElementById('theme-toggle');
        this.loadTheme();
        this.listenToSystemThemeChanges();
        this.attachEvents();
    }
    getStoredPreference() {
        try {
            const preference = localStorage.getItem(this.storageKey);
            if (preference === 'light' || preference === 'dark') return preference;
            return null;
        } catch  {
            return null;
        }
    }
    loadTheme() {
        const storedPreference = this.getStoredPreference();
        if (storedPreference) this.isDark = storedPreference === 'dark';
        else this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.applyTheme();
    }
    listenToSystemThemeChanges() {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change', (event)=>{
            if (this.getStoredPreference()) return;
            this.isDark = event.matches;
            this.applyTheme();
        });
    }
    attachEvents() {
        this.toggleButton?.addEventListener('click', ()=>{
            this.isDark = !this.isDark;
            this.applyTheme();
            this.persistPreference();
        });
    }
    persistPreference() {
        try {
            localStorage.setItem(this.storageKey, this.isDark ? 'dark' : 'light');
        } catch  {
        // Silently ignore storage errors (private / incognito modes)
        }
    }
    applyTheme() {
        document.documentElement.classList.toggle('dark', this.isDark);
        this.updateButtonState();
    }
    updateButtonState() {
        if (!this.toggleButton) return;
        const label = this.isDark ? "Activer le th\xe8me clair" : "Activer le th\xe8me sombre";
        this.toggleButton.setAttribute('aria-label', label);
        this.toggleButton.setAttribute('aria-pressed', String(this.isDark));
        this.toggleButton.dataset.theme = this.isDark ? 'dark' : 'light';
    }
}


const $422ad98dd559aa92$var$ANIMATION_CLASSES = [
    'anim-reveal',
    'anim-reveal-fade',
    'anim-reveal-left',
    'anim-reveal-scale'
];
function $422ad98dd559aa92$export$4ae6feb6159b4594() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        // Make all animated elements immediately visible
        $422ad98dd559aa92$var$ANIMATION_CLASSES.forEach((cls)=>{
            document.querySelectorAll(`.${cls}`).forEach((el)=>{
                el.classList.add('visible');
            });
        });
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
    });
    $422ad98dd559aa92$var$ANIMATION_CLASSES.forEach((cls)=>{
        document.querySelectorAll(`.${cls}`).forEach((el)=>{
            observer.observe(el);
        });
    });
}


function $ad2bcec7a0192558$var$normalizeRouteSegment(segment) {
    if (segment.startsWith('project')) return 'projects';
    return segment || 'home';
}
const $ad2bcec7a0192558$var$routes = [
    {
        path: 'home',
        render: (0, $19ce7e3c9d6231eb$export$7e553efa7989e1cf)
    },
    {
        path: 'projects',
        render: (0, $d634af5b184669af$export$34332b0cbc04fc0d)
    },
    {
        path: 'project/plan-de-travail',
        render: (0, $b3ccd696e766b50c$export$b9d32e483cb00d41)
    },
    {
        path: 'project/agrilib',
        render: (0, $f463fdfade830aad$export$4ef5429a2f4cd619)
    },
    {
        path: 'project/saintnectaire',
        render: (0, $1a34e6f03fa81085$export$62ead6d5ed01702)
    }
];
async function $ad2bcec7a0192558$var$router() {
    try {
        let hash = window.location.hash.slice(1) || 'home';
        if (hash.startsWith('/')) hash = hash.slice(1);
        const route = $ad2bcec7a0192558$var$routes.find((r)=>r.path === hash) || $ad2bcec7a0192558$var$routes[0];
        const app = document.getElementById('app');
        if (!app) {
            console.error('App container not found');
            return;
        }
        if (!app.classList.contains('page-transition')) app.classList.add('page-transition');
        // Fade out
        app.classList.add('fade-out');
        await new Promise((resolve)=>setTimeout(resolve, 250));
        // Update content
        app.innerHTML = route.render();
        // Scroll to top
        window.scrollTo(0, 0);
        // Fade in
        app.classList.remove('fade-out');
        // Move focus for accessibility (announce page change to screen readers)
        app.focus({
            preventScroll: true
        });
        // Initialize scroll animations after DOM update
        setTimeout(()=>{
            (0, $422ad98dd559aa92$export$4ae6feb6159b4594)();
        }, 100);
    } catch (error) {
        console.error('Routing error:', error);
        const app = document.getElementById('app');
        if (app) {
            app.innerHTML = `
        <div class="min-h-[60vh] flex items-center justify-center">
          <div class="text-center container-narrow">
            <h1 class="font-display font-bold text-display-md mb-4" style="color: var(--text-primary)">Une erreur est survenue</h1>
            <p class="font-body text-body-md mb-6" style="color: var(--text-secondary)">La page demandee n'a pas pu etre chargee.</p>
            <a href="#home" class="btn-primary">Retour a l'accueil</a>
          </div>
        </div>
      `;
            app.classList.remove('fade-out');
        }
    }
    // Update active nav link
    document.querySelectorAll('.nav-link').forEach((link)=>{
        link.classList.remove('active');
        link.removeAttribute('aria-current');
        const rawHash = window.location.hash.slice(1) || 'home';
        const sanitizedHash = rawHash.startsWith('/') ? rawHash.slice(1) : rawHash;
        const normalizedBase = $ad2bcec7a0192558$var$normalizeRouteSegment(sanitizedHash.split('/')[0] || sanitizedHash);
        const linkPage = link.getAttribute('data-page');
        if (linkPage === normalizedBase) {
            link.classList.add('active');
            link.setAttribute('aria-current', 'page');
        }
    });
}
// Handle navigation clicks
document.addEventListener('click', (e)=>{
    const target = e.target;
    if (target instanceof HTMLElement && target.matches('.nav-link')) {
        e.preventDefault();
        const page = target.getAttribute('data-page');
        window.location.hash = page || 'home';
    }
});
// Listen to hash changes
window.addEventListener('hashchange', $ad2bcec7a0192558$var$router);
// Navbar scroll behavior
let $ad2bcec7a0192558$var$navbarIsScrolled = false;
function $ad2bcec7a0192558$var$handleScroll() {
    const navbar = document.getElementById('navbar');
    if (!navbar) return;
    const shouldBeScrolled = window.scrollY > 50;
    if (shouldBeScrolled === $ad2bcec7a0192558$var$navbarIsScrolled) return;
    navbar.classList.toggle('scrolled', shouldBeScrolled);
    $ad2bcec7a0192558$var$navbarIsScrolled = shouldBeScrolled;
}
window.addEventListener('scroll', $ad2bcec7a0192558$var$handleScroll, {
    passive: true
});
$ad2bcec7a0192558$var$handleScroll();
// Initial load
$ad2bcec7a0192558$var$router();
// Initialize components
new (0, $c6ec661f1b25b0fd$export$173e0a822059eddc)();
new (0, $0cbfff686ca3cb2c$export$8ad3ff08a59ee147)();


//# sourceMappingURL=portfolio-claude.77a00d80.js.map
